















































import { Component, Prop, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import CancelJobWorkerOfferRequest from '@/models/JobWorkerOffers/CancelJobWorkerOfferRequest';
import JobWorkerOfferDto from '@/models/JobWorkerOffers/JobWorkerOfferDto';
import ListUtils from '@/lib/listUtils';

@Component({
    name: 'JobWorkerOfferStatusSetCancelled'
})
export default class extends GiganautVueDialog {
 
  @Prop({required: true})
  jobWorkerOffer: JobWorkerOfferDto;
  request: CancelJobWorkerOfferRequest = new CancelJobWorkerOfferRequest();

  get job() {
    return JobDetailsModule.currentJob;
  }

  @Watch("dialog")
  async dialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.request = new CancelJobWorkerOfferRequest();
    } 
    this.$emit("closeMenu");
  }

  get items(){
    return ListUtils.jobWorkerOfferCancelledReasons();
  }

  get cancelledReasons() {
    return ListUtils.jobWorkerOfferCancelledReasons();
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    this.request.jobWorkerOfferId = this.jobWorkerOffer.id;
    this.request.updatedAt = this.jobWorkerOffer.updatedAt;
    await JobDetailsModule.cancelJobWorkerOffer(this.request);
    this.dialog = false;
  }
}
